export const BACKEND_ERROR_MESSAGES: Record<string, string> = {
  PHONE_IN_USE: 'El teléfono ya está en uso',
  EMAIL_IN_USE: 'El correo electrónico ya está en uso',
};
